<div class="d-flex full-height gap-16">
  @if (!isCustomerScreen && isNavVisible()) {
    <nav>
      <app-content-box theme="white">
        <div class="d-flex flex-direction-column justify-content-space-between gap-8 full-height">
          <div class="d-flex flex-direction-column gap-8">
            @for (link of navLinks; track link.link) {
              <a
                [routerLink]="link.link | langUrl"
                routerLinkActive="selected"
                class="base-border base-border-radius d-flex align-items-center justify-content-center"
                appTooltip
                placement="right"
                [delay]="tooltipDelay"
                content="{{ link.tooltipText | trans:link.tooltipKey }}"
              >
                <i class="{{ link.icon }}"></i>
              </a>
            }

            <button
              class="base-border base-border-radius d-flex align-items-center justify-content-center"
              (click)="cxEntryModalComponent.open()"
              appTooltip
              placement="right"
              [delay]="tooltipDelay"
              content="{{ 'CXEntry' | trans:'app/nav/cx-entry.Tooltip' }}"
            >
              <i class="ri-qr-scan-line"></i>
            </button>

            @if (isOtsTerminal) {
              <button
                class="base-border base-border-radius d-flex align-items-center justify-content-center"
                (click)="otsStaffModalComponent.open()"
                appTooltip
                placement="right"
                [delay]="tooltipDelay"
                content="{{ 'Order to seat (staff)' | trans:'app/nav/ots-staff.Tooltip' }}"
              >
                <i class="ri-restaurant-2-line"></i>
              </button>
            }

            <button
              class="base-border base-border-radius d-flex align-items-center justify-content-center"
              (click)="searchShowModalComponent.open()"
              appTooltip
              placement="right"
              [delay]="tooltipDelay"
              content="{{ 'Show search' | trans:'app/nav/show-search.Tooltip' }}"
            >
              <i class="ri-search-line"></i>
            </button>
          </div>

          <div class="d-flex flex-direction-column gap-8">
            <button
              class="base-border base-border-radius d-flex align-items-center justify-content-center"
              [appWebCashPermissionControl]="permissionKeys.WebCxCashSafes"
              permittedTooltipContent="{{ 'Cash balance' | trans:'app/nav/cash-balance.Tooltip' }}"
              (click)="safeActionsModalComponent.open()"
              placement="right"
              [delay]="tooltipDelay"
            >
              <i class="ri-token-swap-line"></i>
            </button>

            <button
              class="base-border base-border-radius d-flex align-items-center justify-content-center"
              (click)="cinecardActionsModalComponent.open()"
              [disabled]="isReservationTerminal"
              appTooltip
              placement="right"
              [delay]="tooltipDelay"
              content="{{ 'CineCard' | trans:'app/nav/cinecard.Tooltip' }}"
            >
              <i class="ri-heart-line"></i>
            </button>

            <button
              class="base-border base-border-radius d-flex align-items-center justify-content-center"
              (click)="voucherActionsModalComponent.open()"
              appTooltip
              placement="right"
              [delay]="tooltipDelay"
              content="{{ 'Internal vouchers' | trans:'app/nav/internal-vouchers.Tooltip' }}"
            >
              <i class="ri-gift-line"></i>
            </button>

            <button
              class="base-border base-border-radius d-flex align-items-center justify-content-center"
              [title]="'Customer accounts' | trans:'app/main-layout/customer-accounts-button.Title'"
              (click)="openCustomerAccountsSearch()"
            >
              <i class="ri-user-line"></i>
            </button>

            <button
              class="base-border base-border-radius d-flex align-items-center justify-content-center"
              (click)="actionsModalComponent.open()"
              appTooltip
              placement="right"
              [delay]="tooltipDelay"
              content="{{ 'Actions' | trans:'app/nav/actions.Tooltip' }}"
            >
              <i class="ri-tools-line"></i>
            </button>

            <button
              class="base-border base-border-radius d-flex align-items-center justify-content-center"
              (click)="extrasModalComponent.open()"
              appTooltip
              placement="right"
              [delay]="tooltipDelay"
              content="{{ 'Extras' | trans:'app/nav/extras.Tooltip' }}"
            >
              <i class="ri-rfid-line"></i>
            </button>

            <a
              class="base-border base-border-radius d-flex align-items-center justify-content-center"
              target="_blank"
              href="{{ '' | trans:'app/help-button.Url' }}"
              appTooltip
              placement="right"
              [delay]="tooltipDelay"
              content="{{ 'cinetixx Knowledge Base' | trans:'app/nav/knowledge-base.Tooltip' }}"
            >
              <i class="ri-question-line"></i>
            </a>
          </div>
        </div>
      </app-content-box>
    </nav>
  }

  <div class="d-flex flex-direction-column flex-grow-1">
    @if (terminalsStore.changedCinema()) {
      <app-alert
        type="warning"
        [title]="'Hinweis zum Kinostandort' | trans:'app/cinema-change-alert.Title'"
        [message]="'Du befindest dich gerade im Buchungsvorgang für [[terminalCinema]]. Dein Stammkino ist jedoch [[changedCinema]].' | trans:'app/cinema-change-alert.Text':[['terminalCinema', terminalsStore.selectedTerminal().cinema.name], ['changedCinema', terminalsStore.changedCinema().name]]"
        class="m-b-16"
      >
        <button
          class="button button--xs button--primary m-l-8"
          (click)="restoreTerminalCinema()"
        >
          {{ 'Restore' | trans:'app/cinema-change-alert.RestoreButton' }}
        </button>
      </app-alert>
    }

    @if (isCartLoading()) {
      <div class="d-flex justify-content-center full-height align-items-center">
        <app-loader size="lg" />
      </div>
    } @else {
      <router-outlet />
    }
  </div>

  @if (isCartVisible()) {
    <div class="d-flex flex-direction-column">
      <app-sidebar-cart />
    </div>
  }
</div>

<app-ticket-package-selection-modal
  (onAbort)="onTicketPackageSelectionModalAbort($event)"
/>

<app-actions-modal #actionsModalComponent />

<app-extras-modal
  #extrasModalComponent
  [workerStatusColorClass]="workerStatusColorClass"
  [isCustomerScreenOnline]="isCustomerScreenOnline"
/>

<app-cx-entry-modal #cxEntryModalComponent />

@if (isOtsTerminal && !isCustomerScreen) {
  <app-ots-staff-modal #otsStaffModalComponent />
}

<app-convert-products-to-package-modal #convertProductsToPackageModalComponent />
<app-product-price-picker-modal #productPricePickerModalComponent />

<app-safe-actions-modal #safeActionsModalComponent />

<app-cinecard-actions-modal #cinecardActionsModalComponent />

<app-voucher-actions-modal #voucherActionsModalComponent />

<app-search-show-modal #searchShowModalComponent />

<app-customers-search-modal
  #customersSearchModalComponent
  [showAnonymButton]="false"
  [openDetailsOnRowClick]="true"
  (confirmCustomerSelection)="onCustomerAccountSelected($event)"
/>

<app-customer-details-modal #customerDetailsModalComponent />

<app-show-moved-modal #showMovedModalComponent />

@if (isAnyWsConnectionReconnecting()) {
  <div
    class="position-fixed inset-0 c-bg-gray-100 d-flex align-items-center justify-content-center flex-direction-column ws-overlay"
  >
    <app-loader />
    <p class="p1">
      {{ 'WebSocket reconnecting...' | trans:'app/ws-reconnecting-overlay.Text' }}
    </p>
  </div>
}

@if (!isCustomerScreen) {
  @if (isScanning()) {
    <div
      class="position-fixed inset-0 c-bg-gray-100 d-flex align-items-center justify-content-center flex-direction-column scanning-overlay"
    >
      <app-loader />

      <p class="p1">
        {{ 'Scanning...' | trans:'app/scanning.Text' }}
      </p>

      <button
        class="button button--sm button--strong m-t-32"
        (click)="getProductsByNumberSub?.unsubscribe(); isScanning.set(false)"
      >
        {{ 'Abbrechen' | trans:'app/scanning/cancel.Button' }}
      </button>
    </div>
  }

  <app-modal
    [title]="'Scanned number results' | trans:'app/scanned-val-results-modal/header/title'"
    maxWidth="1200px"
    minWidth="30%"
    width="fit-content"
    [compact]="true"
    #scannedNumberResultsModal
  >
    <ng-template>
      <div class="d-grid gap-12">
        @if (scannedValResults.voucherNr) {
          <button
            class="button button--quick-action"
            (click)="scannedVoucherActions(); scannedNumberResultsModalCloseButton.click()"
          >
            <i class="ri-heart-line"></i>
            {{ 'Voucher' | trans:'app/scanned-val-results-modal/buttons/voucher.Button' }}
          </button>
        }

        @if (scannedValResults.cardNr) {
          <button
            class="button button--quick-action"
            (click)="scannedCardActions(); scannedNumberResultsModalCloseButton.click()"
          >
            <i class="ri-bank-card-line"></i>
            {{ 'Card' | trans:'app/scanned-val-results-modal/card.Button' }}
          </button>
        }

        @if (scannedValResults.product) {
          <button
            class="button button--quick-action"
            (click)="addProductToCart(scannedValResults.product); scannedNumberResultsModalCloseButton.click()"
          >
            <i class="ri-drinks-2-line"></i>
            {{ 'Concession' | trans:'app/scanned-val-results-modal/concession.Button' }}
          </button>
        }
      </div>
    </ng-template>

    <ng-container modal-buttons>
      <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
        <button
          #scannedNumberResultsModalCloseButton
          class="button button--md button--primary-ghost text-uppercase"
          (click)="scannedNumberResultsModal.close(); scannedValResults = null;"
        >
          {{ 'Cancel' | trans:'app/scanned-val-results-modal/cancel.Button' }}
        </button>
      </div>
    </ng-container>
  </app-modal>
}

<app-voucher-amount-picker-modal #voucherAmountPickerModalComponent />
<app-voucher-code-input-modal #voucherCodeInputModalComponent />

<app-card-code-input-modal
  #cardCodeInputModalComponent
  (codeSubmitted)="cardDetailsModalComponent.open({ card: cartStore.customerCards()[0] })"
  (cardPaymentDialogRequired)="cardPaymentBalanceInfoModalComponent.open($event)"
/>
<app-card-payment-balance-info-modal
  #cardPaymentBalanceInfoModalComponent
  (openCardAmountPicker)="cardAmountPickerModalComponent.open($event.cardType, $event.card, $event.loadAmountOffset)"
/>
<app-card-amount-picker-modal
  #cardAmountPickerModalComponent
/>
<app-card-details-modal #cardDetailsModalComponent />
